import ActivityModel from '../../../models/secure/ActivityModel';

const logActivity = async (context, payload) => {
    let activityModel = new ActivityModel();
    return activityModel.logActivity(payload).then(res => {
        context.commit('SET_LOG_RESPONSE', res.data);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            status_code: "ERR1",
            description: err + " - Failed to connect to server for authentication"
        };
    });
}

export {
    logActivity
}
